/** The LightReach (Battery Only) Finance Plan: LightReach Energy Backup offers. */
export const LIGHTREACH_BATTERY_FINANCE_TYPE = `lightreach_battery`
